import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const locations = [
  {
    title: "Crown Range Road",
    tag: "Alpine Pass · Panorama",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/9m3nb1j7_Screenshot%202026-05-11%20at%205.33.21%E2%80%AFPM.png",
  },
  {
    title: "High Country Tussock",
    tag: "Tussock · Open Sky",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/pheowo73_IMG_5635.jpeg",
  },
  {
    title: "Kawarau River",
    tag: "Turquoise · Gorge",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/690r230d_IMG_2460.jpeg",
  },
  {
    title: "Kawarau–Nevis Confluence",
    tag: "River · Aerial Gorge",
    img: "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/3dy7zhyg_DJI_0636.JPG",
  },
];

export default function Locations() {
  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#E2B464]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E2B464]">
                02 — Locations
              </span>
            </div>
            <h2 className="font-display font-light text-4xl md:text-6xl leading-none tracking-tighter max-w-3xl">
              10,000+ hectares. <span className="italic">Five continents</span>{" "}
              of landscape.
            </h2>
          </div>
          <p className="text-zinc-400 max-w-sm leading-relaxed text-sm">
            Long held New Zealand stations spanning more than 10,000 ha,
            featuring many of the country's most regarded international shooting
            locations, all within reach of the Victoria Flats backlot.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {locations.map((loc, i) => (
            <motion.button
              key={loc.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-testid={`location-card-${i}`}
              className="group relative overflow-hidden aspect-[4/5] text-left border border-white/10 hover:border-[#E2B464]/60 transition-colors"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                style={{ backgroundImage: `url(${loc.img})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
                <div className="flex items-start justify-between">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-300 bg-black/40 backdrop-blur px-2.5 py-1 border border-white/10">
                    {loc.tag}
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl text-white tracking-tight leading-tight">
                    {loc.title}
                  </h3>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
